import script from "./Jbqk.vue?vue&type=script&setup=true&lang=js"
export * from "./Jbqk.vue?vue&type=script&setup=true&lang=js"

import "./Jbqk.vue?vue&type=style&index=0&id=3efa43ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3efa43ae"]])

export default __exports__